function trimPublicSiteUrl(raw: string | undefined) {
  const trimmed = raw?.trim();
  if (!trimmed) return undefined;
  return trimmed.replace(/\/$/, "");
}

function resolveSummerCampPublicUrl() {
  const fromEnv =
    typeof process !== "undefined"
      ? trimPublicSiteUrl(process.env.SUMMER_CAMP_PUBLIC_URL)
      : undefined;
  if (fromEnv) return fromEnv;
  if (
    typeof process !== "undefined" &&
    process.env.NODE_ENV !== "production"
  ) {
    return "http://localhost:3001";
  }
  return "https://summer2026.fanglaostudio.com";
}

function resolveLihfPublicUrl() {
  const fromEnv =
    typeof process !== "undefined"
      ? trimPublicSiteUrl(process.env.LIHF_PUBLIC_SITE_URL)
      : undefined;
  if (fromEnv) return fromEnv;
  if (
    typeof process !== "undefined" &&
    process.env.NODE_ENV !== "production"
  ) {
    return "http://localhost:3001";
  }
  return "https://lihf.fanglaostudio.com";
}

export const config = {
  apiUrl: window.location.origin + "/api",
  authUrl: window.location.origin + "/api/auth",
  brandName: "Fanglao Studio",
  /** ที่อยู่สำหรับแสดงบนบิล/ใบเสร็จ */
  brandAddress: "VIENTIANE CENTER, 4th floor",
  brandAddressLo: "ວຽງຈັນເຊັນເຕີ, ຊັ້ນ4",
  /** ข้อความ footer บิล (บรรทัดแรก) */
  billFooterTagline: "Keep Dancing, Keep Moving!",
  /** เว็บ Summer Camp สาธารณะ (ฟอร์มผู้เข้าชม /register/visitor) */
  summerCampPublicUrl: resolveSummerCampPublicUrl(),
  /** เว็บ LIHF สาธารณะ (ฟอร์มลงทะเบียน /{locale}/register/…) */
  lihfPublicUrl: resolveLihfPublicUrl(),
};

export const isDevMode = import.meta.hot !== undefined;

export function visitorRegistrationPublicUrl() {
  return `${config.summerCampPublicUrl}/register/visitor`;
}
